export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7841.1c5c82b0.jpg";